import React from "react";
import type { ProcessedBetEntry } from "@/hooks/firestore/betting/useEntries";

import { isEntryCashedOut } from "features/entries/util/entry-helpers";
import {
  BetOddsSummary,
  BetPayout,
  BetStake,
  BetStakePerCombo,
  BetSummary,
  BetSummaryAction,
} from "./BetSummary";
import {
  isExoticSelection,
  isQuaddieSelection,
} from "features/entries/util/type-guards";

interface BetEntrySummaryProps {
  entry: ProcessedBetEntry;
  isCompact?: boolean;
  isPreview?: boolean;
}

const BetEntrySummary = ({
  entry,
  isCompact = false,
  isPreview = false,
}: BetEntrySummaryProps) => {
  const isShared = !!entry.shareId;
  const hideStake = entry.hideStake;
  const isCashedOut = isEntryCashedOut(entry);
  const isEntryWon = entry.data.result === "WIN";

  const isCombo = !!entry.data.selectionsRequiredToWin;
  const isExotic = isExoticSelection(entry.data.selections[0]);
  const isQuaddie = isQuaddieSelection(entry.data.selections[0]);

  return (
    <BetSummary
      entry={entry}
      isCompact={isCompact}
      isWon={isEntryWon}
      isCashedOut={isCashedOut}
    >
      <BetStake
        omitStakeValue={hideStake}
        separator={!isPreview && <div>&times;</div>}
        label={isCombo || isExotic ? "Total Stake" : "Stake"}
      />
      {isCombo || isExotic || isQuaddie ? (
        <BetStakePerCombo
          omitStakeValue={hideStake}
          separator={!hideStake && !isPreview && <div>=</div>}
        />
      ) : (
        <BetOddsSummary separator={!hideStake && !isPreview && <div>=</div>} />
      )}
      {!hideStake && <BetPayout />}

      {!isShared && !isPreview && <BetSummaryAction />}
    </BetSummary>
  );
};

export { BetEntrySummary };
